module.exports = __webpack_public_path__ + "img/poziom6.2639788d.svg";